import {
  createContext,
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  useContext,
  useState,
} from 'react';

import {
  allBuildingRecords,
  allInspections,
} from '@/pages/Tools/BuildingInspection/dummy_data/dummy_data';
import { allFees } from '@/pages/Tools/BuildingInspection/dummy_data/dummy_fees';
import { allViolations } from '@/pages/Tools/BuildingInspection/dummy_data/dummy_violations';
import { visitNotesList } from '@/pages/Tools/BuildingInspection/dummy_data/dummy_visit_notes';
import {
  BuildingInspection,
  BuildingRecord,
  IFee,
  IViolation,
  IVisit,
  IVisitNote,
} from '@/pages/Tools/BuildingInspection/Models';

type BuildingInspectionContextProviderProps = PropsWithChildren;

interface BuildingInspectionContextValues
  extends Omit<BuildingInspectionContextProviderProps, 'children'> {
  buildingRecords: BuildingRecord[];
  setBuildingRecords: Dispatch<SetStateAction<BuildingRecord[]>>;
  setInspections: Dispatch<SetStateAction<BuildingInspection[]>>;
  inspections: BuildingInspection[];
  setInspectionVisits: Dispatch<SetStateAction<IVisit[]>>;
  inspectionVisits: IVisit[];
  fees: IFee[];
  setFees: Dispatch<SetStateAction<IFee[]>>;
  visitNotes: IVisitNote[];
  setVisitNotes: Dispatch<SetStateAction<IVisitNote[]>>;
  violations: IViolation[];
  setViolations: Dispatch<SetStateAction<IViolation[]>>;
  updateViolation: (id: string, update: Partial<IViolation>) => void;
  // currentArrestCharge?: IArrestCharge;
  // setCurrentArrestCharge: (newArrestCharge?: IArrestCharge) => void;
  // currentArrestFile?: IFile;
  // setCurrentArrestFile: (newFile?: IFile) => void;
  // arrestDrawer: ArrestDrawer;
  // setArrestDrawer: (newArrestDrawer: ArrestDrawer) => void;
}

const BuildingInspectionContext = createContext<
  BuildingInspectionContextValues | undefined
>(undefined);

export function useBuildingInspectionContext() {
  const context = useContext(BuildingInspectionContext);
  if (!context) {
    throw new Error(
      'useBuildingInspectionContext must be used within a BuildingInspectionContextProvider',
    );
  }
  return context;
}

export function BuildingInspectionContextProvider({
  children,
}: BuildingInspectionContextProviderProps) {
  const [buildingRecords, setBuildingRecords] =
    useState<BuildingRecord[]>(allBuildingRecords);

  const [inspections, setInspections] =
    useState<BuildingInspection[]>(allInspections);

  const [violations, setViolations] = useState<IViolation[]>(allViolations);
  const [visitNotes, setVisitNotes] = useState<IVisitNote[]>(visitNotesList);
  const [inspectionVisits, setInspectionVisits] = useState<IVisit[]>([
    {
      _id: '50auvs2l',
      inspection_id: 'ins-001-1',
      scheduledDateTime: '11/13/2025',
      violation_ids: ['v1', 'v2'],
      note_ids: ['vn1', 'vn2', 'vn3', 'vn4', 'vn4', 'vn5'],
      status: 'Failed',
      inspectionFee: 21,
      backdateInspection: true,
      name: 'asd',
      title: 'asd',
      businessName: '',
      businessPhone: '',
      cellPhone: '',
      emailAddress: '',
      assignedTo: '',
      includePhotosInReport: false,
      additionalEmails: [],
    },
  ]);
  const [fees, setFees] = useState<IFee[]>(allFees);

  const updateViolation = (id: string, update: Partial<IViolation>) => {
    setViolations((prev) =>
      prev.map((record) =>
        record._id === id ? { ...record, ...update } : record,
      ),
    );
  };

  return (
    <BuildingInspectionContext.Provider
      value={{
        buildingRecords,
        setBuildingRecords,
        inspections,
        setInspections,
        fees,
        setFees,
        violations,
        setViolations,
        updateViolation,
        visitNotes,
        setVisitNotes,
        inspectionVisits,
        setInspectionVisits,
        // ...rest,
      }}
    >
      {children}
    </BuildingInspectionContext.Provider>
  );
}
